import React from 'react';
import { getDefaultformFields } from '../utilities/form-utilities';
import SPGVariables from '../../../utilities/spg-variables';
import APIManager from '../../../utilities/api-manager';
import { constructCoalitionRATEmail } from '../../../utilities/construct-email';
import { getText } from '../../../helpers';

const RequestTrialForm = React.lazy(() => import('../index' /* webpackChunkName: "request-a-trial-form" */));

const formText = getText('pages.requestTrial');
const spgVariables = SPGVariables();
function getMailingList(variant: string): string {
    if (variant === 'coalition') {
        return spgVariables.COALITIONEMAILLIST;
    }

    return '';
}

const emailStatusCallback = (hasRequestSuccess: boolean, successCallback: () => void, error: (error: string) => void) => {
    if (hasRequestSuccess) {
        successCallback();
    } else {
        error('Caolition request  failed');
    }
};

function RequestCoalitionTrialEmail(props: RequestATrialFormProps) {
    const { productName = '', productVariant, variant = '', titleText, ratVariant } = props;
    const onSubmit = (data: RequestATrialState, cb: () => void, error: (error: string) => void) => {
        let notapplicableText = data.InterestArea ? '' : 'Data Management Solutions';
        if (productVariant === 'solution') notapplicableText = productName;
        data.InterestArea = data.InterestArea ? data.InterestArea.replace(/,/g, ';') : '';
        APIManager.sendEmail(
            constructCoalitionRATEmail(productName, data),
            formText.emailSubject.replace('{productName}', productName),
            getMailingList(variant),
            (isSuccess: boolean) => {
                emailStatusCallback(isSuccess, cb, error);
            }
        );
    };
    return <RequestTrialForm onSubmitForm={onSubmit} formTextFields={getDefaultformFields()} productVariant={productVariant} titleText={titleText} ratVariant={ratVariant} />;
}

export default React.memo(RequestCoalitionTrialEmail);
